export const not_chosen_boiler_model = 'Другая';
export const prepare_boiler_models = (loaded) => {
    let result = [];
    if (loaded.length) {
        result = loaded
            // remove not chosen boiler model because MUI doesn't support that form, added later
            .filter((model) => model.zont_id != '')
            .map((model) => ({
            group: model.brand,
            text: model.title,
            value: model.zont_id,
        }));
        result = [
            ...result,
            {
                group: 'Остальные',
                text: not_chosen_boiler_model,
                value: not_chosen_boiler_model,
            },
        ];
    }
    return result;
};
export const getBoilerModels = () => async (dispatch, getState, { api }) => {
    dispatch({ type: 'LOAD_BOILERS__REQUEST' });
    try {
        const { boiler_models } = await api.get_boiler_models_v2();
        const boiler_models_flat = prepare_boiler_models(boiler_models);
        dispatch({
            type: 'LOAD_BOILERS__OK',
            data: { boiler_types: boiler_models, boiler_models: boiler_models_flat },
        });
    }
    catch (error) {
        dispatch({
            type: 'LOAD_BOILERS__FAIL',
            error,
        });
    }
};
